import { FaCode, FaHome } from "react-icons/fa";
import { FaServicestack, FaUserGroup } from "react-icons/fa6";

export interface SidebarItem {
  name: string;
  icon: any;
  url: string;
}
export const adminSidebarItems: SidebarItem[] = [
   {
    name: "Dashboard",
    icon: FaHome,
    url: "/superadmin",
  },
  {
    name: "Users",
    icon: FaUserGroup,
    url: "/superadmin/users",
  },
   {
    name: "Short Codes",
    icon: FaCode,
    url: "/superadmin/short-codes",
  },
  {
    name: "Bot Ids",
    icon: FaCode, 
    url: "/superadmin/bot-ids",
  },
  {
    name: "Voice Bot",
    icon: FaCode,
    url: "/superadmin/voice-bots",
  },
  {
    name: "Subscriptions",
    icon: FaUserGroup,
    url: "/superadmin/subscriptions",
  },
  {
    name: "Settings",
    icon: FaServicestack,
    url: "/superadmin/config",
  },
  {
    name: "Feedback",
    icon: FaCode,
    url: "/superadmin/feedback",
  }
]